eslint-disable vue/multi-word-component-names
<!-- <template>
    <div class="home">
        <h1>Hello user, welcome to home page  {{ $t('account') }}</h1>

        <h4>TO BE DONE</h4>
        <h6>How to apply Vuetify search in datatable when column data is also an array</h6>
        <h6>Export to excel/cvs</h6>
        <h6>language english / french</h6>
        <h6>{{this.global_permissions}}</h6>

        <v-btn color="secondary" prepend-icon="mdi-plus" @click="reload">testing</v-btn>           
                       
        
        
    </div>

    <div>
      <v-data-table
        v-model:page="page"
        :headers="headers"
        :items="desserts"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:top>
          <v-text-field
            :model-value="itemsPerPage"
            class="pa-2"
            label="Items per page"
            max="15"
            min="-1"
            type="number"
            hide-details
            @update:model-value="itemsPerPage = parseInt($event, 10)"
          ></v-text-field>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </div>

    
  </template> -->

<template>
  <body>
    <h2>{{ $t("dashboard") }}</h2>

    <div
    
      class="d-flex justify-center align-end text-caption"
      style="height: 80vh"
    >
      <div
        class="d-flex flex-column align-start h-100 w-75 mr-2"
        style="min-width: 600px"
      >
        <div class="d-flex flex-column mb-3 w-100">
          <v-sheet>
            <v-img
              class="rounded-lg"
              style="width: 100%; height: 200px"
              aspect-ratio="16/9"
              cover
              src="../assets/images/home_image_3.jpg"
            ></v-img>
          </v-sheet>
          <v-sheet class="mt-4">
            <div
              class="d-flex justify-space-between rounded-sm bg-blue-grey-darken-4 pa-1"
            >
            {{ $t("devicesPreview") }}
              <router-link class="link" to="/devices">{{ $t("see_more") }}</router-link>
            </div>
          </v-sheet>

          <v-card>
            <v-data-table
              :headers="terminal_headers"
              :items="devices"
              :items-per-page="5"
              :disable-pagination="true"
              class="elevation-1 table-style"
              height="230"
            ><template #bottom v-if="!showFooter"></template></v-data-table>
          </v-card>

          <v-sheet class="mt-6">
            <div
              class="d-flex justify-space-between rounded-sm bg-blue-grey-darken-4 pa-1"
            >
            {{ $t("merchantPreview") }}
              <router-link class="link" to="/merchant">{{ $t("see_more") }}</router-link>
            </div>
          </v-sheet>

          <v-card>
            <v-data-table
              class="elevation-1 table-style"
              :headers="merchant_headers"
              :items="merchants"
               :items-per-page="5"
              :disable-pagination="true"
              height="230"
            >
            <template #bottom v-if="!showFooter"></template>
            </v-data-table>
          </v-card>
        </div>
      </div>
      <div
        class="d-flex flex-column align-start rounded h-100 w-25"
        style="min-width: 400px"
      >
        <div class="d-flex flex-column w-100">
          <v-sheet class="ma-2">
            <div class="rounded-lg bg-blue-grey-darken-4 pa-2">
              {{ $t("generalOverview") }}
            </div>
          </v-sheet>
          <v-sheet class="ma-2 rounded-lg" style="background-color: #bbebef"
          v-if="(this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER'))">
            <div class="cardDetail">
              <div class="img">
                <v-icon icon="mdi mdi-cellphone-settings"></v-icon>
              </div>
              <div class="text">
                <h2>{{this.nbrTerminals}}</h2>
                <p>{{ $t("terminalText") }}</p>
              </div>
            </div>
          </v-sheet>
          <v-sheet class="ma-2 rounded-lg" style="background-color: #d4d8f1">
            <div class="cardDetail">
              <div class="img">
                <v-icon icon="mdi mdi-point-of-sale"></v-icon>
              </div>
              <div class="text">
                <h2>{{this.nbrDevices}}</h2>
                <p>{{ $t("devicesText") }}</p>
              </div>
            </div>
          </v-sheet>
          <!-- <v-sheet class="ma-2 rounded-lg" style="background-color: #eebbc2"
          v-if="(this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER'))">
            <div class="cardDetail">
              <div class="img">
                <v-icon icon="mdi mdi-card-account-details"></v-icon>
              </div>
              <div class="text">
                <h2>{{this.nbrLicenses}}</h2>
                <p>{{ $t("licenseText") }}</p>
              </div>
            </div>
          </v-sheet> -->
          <v-sheet class="ma-2 rounded-lg" style="background-color: #f7d6ab">
            <div class="cardDetail">
              <div class="img">
                <v-icon icon="mdi-account-group-outline"></v-icon>
              </div>
              <div class="text">
                <h2>{{this.nbrMerchants}}</h2>
                <p>{{ $t("merchantText") }}</p>
              </div>
            </div>
          </v-sheet>
          <v-sheet class="ma-2 rounded-lg" style="background-color: #f3f6ff"
          v-if="(this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER'))">
            <div class="cardDetail">
              <div class="img">
                <v-icon icon="mdi-account-group-outline"></v-icon>
              </div>
              <div class="text">
                <h2>{{this.nbrOrganizations}}</h2>
                <p>{{ $t("organisationText") }}</p>
              </div>
            </div>
          </v-sheet>
        </div>
      </div>
    </div>
  </body>
</template>

<!-- <script setup>
    import { computed, ref } from 'vue'

    const page = ref(1)
    const itemsPerPage = ref(5)
    const headers = ref([
      {
        align: 'start',
        key: 'name',
        sortable: false,
        title: 'Dessert (100g serving)',
      },
      { title: 'Calories', key: 'calories' },
      { title: 'Fat (g)', key: 'fat' },
      { title: 'Carbs (g)', key: 'carbs' },
      { title: 'Protein (g)', key: 'protein' },
      { title: 'Iron (%)', key: 'iron' },
    ])
    const desserts = ref([
      {
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6,
        carbs: 24,
        protein: 4,
        iron: 1,
      },
      {
        name: 'Ice cream sandwich',
        calories: 237,
        fat: 9,
        carbs: 37,
        protein: 4.3,
        iron: 1,
      },
      {
        name: 'Eclair',
        calories: 262,
        fat: 16,
        carbs: 23,
        protein: 6,
        iron: 7,
      },
      {
        name: 'Cupcake',
        calories: 305,
        fat: 3.7,
        carbs: 67,
        protein: 4.3,
        iron: 8,
      },
      {
        name: 'Gingerbread',
        calories: 356,
        fat: 16,
        carbs: 49,
        protein: 3.9,
        iron: 16,
      },
      {
        name: 'Jelly bean',
        calories: 375,
        fat: 0,
        carbs: 94,
        protein: 0,
        iron: 0,
      },
      {
        name: 'Lollipop',
        calories: 392,
        fat: 0.2,
        carbs: 98,
        protein: 0,
        iron: 2,
      },
      {
        name: 'Honeycomb',
        calories: 408,
        fat: 3.2,
        carbs: 87,
        protein: 6.5,
        iron: 45,
      },
      {
        name: 'Donut',
        calories: 452,
        fat: 25,
        carbs: 51,
        protein: 4.9,
        iron: 22,
      },
      {
        name: 'KitKat',
        calories: 518,
        fat: 26,
        carbs: 65,
        protein: 7,
        iron: 6,
      },
    ])
    const pageCount = computed(() => {
      return Math.ceil(desserts.value.length / itemsPerPage.value)
    })
  </script> -->

<script>
import axios from "axios";
export default {
  name: "Home",

  data() {
    return {
      page: 1,
      itemsPerPage: 5,
      loading: true,
      devices: [],
      merchants: [],
      nbrMerchants: 0,
      nbrTerminals: 0,
      nbrDevices: 0,
      nbrOrganizations: 0,
      nbrLicenses: 0,
      licenses: [],
      terminal_headers: [
        {
          align: "start",
          key: "deviceSN",
          sortable: false,
          title: "Device SN",
        },
        { title: "Merchant", key: "merchant.merchantName" },
        { title: "Merchant Address", key: "merchant.merchantAddress" },
      ],


      merchant_headers: [
        {
          align: "start",
          title: "Merchant Name",
          sortable: false,
          key: "merchantName",
        },
        { title: "merchant Address", key: "merchantAddress" },
        //{ title: "merchant", key: "merchant.merchantAddress" },
      ],
    };
  },
  computed: {
    // pageCount() {
    //   return Math.ceil(this.desserts.length / this.itemsPerPage);
    // },
  },

  method: {
    // reload() {
    //   this.$emit("reloadChild");
    //   console.log("id", "refreshing1");
    // },

    fetchData() {
      // console.log("id", "hhhhh");
      // console.log("OrgID", this.orgId);

      //let result;
      //let page2 = this.page - 1;
      //try {
        if ( this.global_permissions.includes("ROLE_STAFF_ADMIN") || this.global_permissions.includes("ROLE_STAFF_USER") ) {
          
          axios.all([
            axios.get(window.baseurl + "devices", 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "merchants", 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "terminals/number", 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "merchants/number", 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
          ])
          .then(
            axios.spread((devices_response, merchants_response, nbr_terminals_response, nbr_merchants_response) => {
              // console.log("data1", devices_response.data);
              // console.log("data2", merchants_response.data);
              // console.log("data3", nbr_terminals_response.data);
              // console.log("data4", nbr_merchants_response.data);

              //if response data is a single object
              if (devices_response.status == 200) {
                this.devices = []; 
                this.devices = devices_response.data.records;                
              }

              if (merchants_response.status == 200) {
                this.merchants = []; 
                this.merchants = merchants_response.data.records;                
              }

              if (nbr_terminals_response.status == 200) {                
                this.nbrTerminals = nbr_terminals_response.data;                
              }

              if (nbr_merchants_response.status == 200) {                
                this.nbrMerchants = nbr_merchants_response.data;                
              }
            })
          );
        }  
        
        
      
    },


  },

  async mounted() {
    this.checkTokenExpiry();

    //get user list
    //this.fetchData();

    if ( this.global_permissions.includes("ROLE_STAFF_ADMIN") || this.global_permissions.includes("ROLE_STAFF_USER") ) {
          
          axios.all([
            axios.get(window.baseurl + "devices", 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "merchants", 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "terminals/number", 
              {                
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "merchants/number", 
              {                
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "devices/number", 
              {                
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "organizations/number", 
              {                
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "licenses", 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
          ])
          .then(
            // axios.spread((devices_response, merchants_response, nbr_terminals_response, nbr_merchants_response, nbr_devices_response, nbr_org_response,licenses) => {
            axios.spread((devices_response, merchants_response, nbr_terminals_response, nbr_merchants_response, nbr_devices_response, nbr_org_response) => {
              // console.log("data1", devices_response.data);
              // console.log("data2", merchants_response.data);
              // console.log("data3", nbr_terminals_response.data);
              // console.log("data4", nbr_merchants_response.data);
              // console.log("data5", nbr_devices_response.data);
              // console.log("data6", nbr_org_response.data);
              // console.log("license",licenses);

              //if response data is a single object
              if (devices_response.status == 200) {
                this.devices = []; 
                this.devices = devices_response.data.records;                
              }

              if (merchants_response.status == 200) {
                this.merchants = []; 
                this.merchants = merchants_response.data.records;                
              }

              if (nbr_terminals_response.status == 200) {                
                this.nbrTerminals = nbr_terminals_response.data;                
              }

              if (nbr_merchants_response.status == 200) {                
                this.nbrMerchants = nbr_merchants_response.data;                
              }

              if (nbr_devices_response.status == 200) {                
                this.nbrDevices = nbr_devices_response.data;                
              }

              if (nbr_org_response.status == 200) {                
                this.nbrOrganizations = nbr_org_response.data;                
              }
              // if(licenses.status == 200){
              //   this.nbrLicenses = licenses.data.totalRecords;
              // }
            })
          );
    } 
    else if ( this.global_permissions.includes("ROLE_USER_ADMIN") || this.global_permissions.includes("ROLE_USER_ASSIST") ) {
          
          axios.all([
            axios.get(window.baseurl + "devices/org/" + this.orgId, 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "merchants/org/" + this.orgId, 
              {
                params: { pagesize: 5 },
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "terminals/org/number/" + this.orgId, 
              {                
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "merchants/org/number/" + this.orgId, 
              {                
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            axios.get(window.baseurl + "devices/org/number/" + this.orgId, 
              {                
                headers: { Authorization: "Bearer " + this.accessToken },
              }
            ),
            
          ])
          .then(
            axios.spread((devices_response, merchants_response, nbr_terminals_response, nbr_merchants_response, nbr_devices_response) => {
              // console.log("data1", devices_response.data);
              // console.log("data2", merchants_response.data);
              // console.log("data3", nbr_terminals_response.data);
              // console.log("data4", nbr_merchants_response.data);
              // console.log("data5", nbr_devices_response.data);
              

              //if response data is a single object
              if (devices_response.status == 200) {
                this.devices = []; 
                this.devices = devices_response.data.records;                
              }

              if (merchants_response.status == 200) {
                this.merchants = []; 
                this.merchants = merchants_response.data.records;                
              }

              if (nbr_terminals_response.status == 200) {                
                this.nbrTerminals = nbr_terminals_response.data;                
              }

              if (nbr_merchants_response.status == 200) {                
                this.nbrMerchants = nbr_merchants_response.data;                
              }

              if (nbr_devices_response.status == 200) {                
                this.nbrDevices = nbr_devices_response.data;                
              }

            })
          );
    }  
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cardDetail {
  display: flex;
  height: 120px;
  align-items: center;
  border-radius: 20px;
  gap: 18px;
}

.cardDetail .img {
  background-color: #434961;
  width: 60px;
  height: 60px;
  margin-left: 20px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
}

.cardDetail .text {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
}

.cardDetail .text h2 {
  font-size: 60px;
  color: #24293e;
  margin-top: 15px;
}

.cardDetail .text p {
  color: #24293e;
  margin-top: 22px;
}

.link {
  color: #fff;
  text-decoration: none;
  margin-right: 10px;
}

.link:hover {
  color: #bbebef;
}

.table-style {
  font-size: 12px;
  padding: 0px;
}

</style>
